import { useRef, useState, useEffect } from 'react';

const THRESHOLD = 65; // px bis Refresh ausgelöst wird
const MAX_PULL  = 80; // maximale visuelle Pull-Distanz

export function usePullToRefresh(containerRef, onRefresh) {
  const [pullY, setPullY]       = useState(0);
  const [refreshing, setRefreshing] = useState(false);

  // Ref damit der Callback immer aktuell ist ohne Effect neu zu starten
  const onRefreshRef = useRef(onRefresh);
  onRefreshRef.current = onRefresh;

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // Lokale Gesture-State (kein Re-render nötig)
    let startY    = 0;
    let pulling   = false;
    let currentY  = 0;

    const touchStart = (e) => {
      if (el.scrollTop > 2) return; // nur an ganz oben
      startY   = e.touches[0].clientY;
      pulling  = true;
      currentY = 0;
    };

    const touchMove = (e) => {
      if (!pulling) return;
      const delta = e.touches[0].clientY - startY;
      if (delta <= 0) { pulling = false; currentY = 0; setPullY(0); return; }
      e.preventDefault(); // iOS scroll-bounce unterdrücken
      currentY = Math.min(delta * 0.4, MAX_PULL);
      setPullY(currentY);
    };

    const touchEnd = async () => {
      if (!pulling) return;
      pulling = false;
      const dist = currentY;
      currentY = 0;
      setPullY(0);
      if (dist >= THRESHOLD) {
        setRefreshing(true);
        await onRefreshRef.current();
        setRefreshing(false);
      }
    };

    el.addEventListener('touchstart', touchStart, { passive: true });
    el.addEventListener('touchmove',  touchMove,  { passive: false }); // muss non-passive sein für preventDefault
    el.addEventListener('touchend',   touchEnd,   { passive: true });

    return () => {
      el.removeEventListener('touchstart', touchStart);
      el.removeEventListener('touchmove',  touchMove);
      el.removeEventListener('touchend',   touchEnd);
    };
  }, []); // einmal mounten, Callback via Ref immer aktuell

  return { pullY, refreshing };
}
